import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {msg} from '@lit/localize';
import {connect} from 'pwa-helpers';
import store from '../../store';
import plus from '../../../icons/plus';

@customElement('light-profile-spc-widget-addon')
export class LightProfileSpcWidgetAddon extends connect(store)(LitElement) {

	static styles = [
		css`
			:host {

			}
			.addon {
				padding-top: var(--padding);
			}
			.link {
				display: flex;
				gap: var(--padding);
				flex-direction: row;
				justify-content: end;
				line-height: 0;
				align-items: center;
			}
			.label {
				font: var(--font-widget-info);
				color: var(--color-widget-text);
				text-decoration: none;
			}
			.icon {
				width: 1rem;
				color: var(--color-widget-text);
			}
		`];


	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	render() {
		return html`
			<div class="addon">
				<a class="link" target="_blank" href="https://selux.com/configuration/ger/de/LightProfile/sections/external/new">
					<span class="label">${msg('Detailed configuration of Light Profiles')}</span>
					<span class="icon">${plus}</span>
				</a>
			</div>
        `;
	}
}
